import React from 'react'

const Ecologyanddevelopment = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. Match the words with their meanings.</p>
        <p>Constituency ------ electoral district</p>
        <p>Pursue ------ to follow in an effort to overtake or capture</p>
        <p>Infiltrate ------ to enter or gain access to (an organization, place, etc.) secretly and gradually</p>
        <p>Nomadic ------ living the life of roaming</p>
        <p>Anatomy ------ art of studying the different parts of any organized body</p>
        <p>Subversive ------ seeking or intended to overthrow an established system or institution</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Make two other words by using each prefix given above and use them in sentences.</p>
        <strong>mal</strong>
        <p>Malfunction- The computer began to malfunction and stopped working properly.</p>
        <p>Malnourished- The doctor said the child was malnourished because he wasn't eating enough healthy food.</p>
        <strong>mis</strong>
        <p>Misunderstand- He misunderstood the homework instructions and did the wrong assignment.</p>
        <p>Misplace- I always misplace my keys and spend time looking for them.</p>
        <strong>un</strong>
        <p>Unkind- It was unkind of him to laugh at her mistake.</p>
        <p>Unfair- It's unfair to blame her without knowing the full story.</p>
        <strong>in</strong>
        <p>Invisible- The stars became invisible during the day.</p>
        <p>Incorrect- The teacher marked the math problem as incorrect because the calculation was wrong.</p>
        <strong>pre</strong>
        <p>Preview- We watched the preview of the movie before it was released.</p>
        <p>Preheat- Don't forget to preheat the oven before baking the cake.</p>
        <strong>il</strong>
        <p>Illegal- It is illegal to drive without a license.</p>
        <p>Illogical- His explanation was illogical and didn't make any sense.</p>
        <strong>dis</strong>
        <p>Disagree- I disagree with your opinion, but I still respect it.</p>
        <p>Disappear- The magician made the coin disappear in his hand.</p>
        <strong>im</strong>
        <p>Impossible- It's impossible to lift that heavy rock alone.</p>
        <p>Impolite- It is impolite to interrupt someone while they are speaking.</p>
        <strong>Re</strong>
        <p>Rewrite- I had to rewrite my essay to make it better.</p>
        <p>Replay- We watched the replay of the exciting soccer match</p>
        <strong>ir</strong>
        <p>Irregular- The teacher noticed that his attendance was irregular last month.</p>
        <p>Irresponsible- It is irresponsible to leave your homework unfinished.</p>
        <strong>de</strong>
        <p>Deactivate- Please deactivate your account if you no longer want to use the service.</p>
        <p>Decrease- The company plans to decrease the prices of its products next month.</p>
        <strong>non</strong>
        <p>Nonsense- It's nonsense to say that you can fly without wings.</p>
        <p>Nonstop- The train ran nonstop from Kathmandu to Pokhara.</p>
      </div>
      <hr/>
      <div>
        <h3>Comprehension</h3>
        <p className='question'>Answer these questions.</p>
        <p className='question'>a. What did Maathai decide to do for the community?</p>
        <p>= Maathai decided to help the community by creating jobs and encouraging people to plant trees to improve the environment and their lives.</p>
        <p className='question'>b. Mention the problems faced by women in Kenya.</p>
        <p>= The problems faced by women in Kenya included malnutrition, lack of food and clean water, unemployment, and soil erosion.</p>
        <p className='question'>c. Why did the speaker go to the women to talk about planting trees?</p>
        <p>= The speaker went to the women to talk about planting trees because they were the most affected by problems like lack of firewood, malnutrition, food and water shortages, unemployment, and soil erosion. They were also deeply concerned about their children and the future.</p>
        <p className='question'>d. What is the most important achievement of the movement described in the text?</p>
        <p>= The most important achievement of the movement is that women became independent, gained knowledge and skills, and felt empowered. They also started teaching and supporting each other.</p>
        <p className='question'>e. Why were the foresters' ways not helpful to the women for planting trees?</p>
        <p>= The foresters' ways were not helpful to the women because they made the simple task of finding seeds and planting trees seem too complicated.</p>
        <p className='question'>f. When and how did she start The Green Belt Movement?</p>
        <p>= She started The Green Belt Movement on World Environment Day by planting the first seven trees with the community.</p>
        <p className='question'>g. Why do the donors want to provide money to the women?</p>
        <p>= The donors want to provide money to the women because their efforts were showing good results and making a real difference in the community.</p>
        <p className='question'>h. What happened when the speaker criticized the political leadership?</p>
        <p>= When the speaker criticized the political leadership, she was portrayed as subversive and treated as if she was a threat to the government.</p>
        <p className='question'>i. Mention the agencies that supported her movement.</p>
        <p>= The agencies that supported her movement are:
          </p><p>
1. United Nations Development Fund for Women
</p><p>
2. Danish Voluntary Fund</p><p>
3. Norwegian Agency for International Development</p><p>
4. African Development Foundation</p>
      </div>
      <hr/>
      <div>
        <h3>Critical thinking</h3>
        <p className='question'>a. Do you think that the title “Foresters without Diplomas” is suitable to the essay? How?</p>
        <p>= Yes, I believe the title “Foresters without Diplomas” is very suitable for the essay. The title reflects the main idea of the essay, which is about how ordinary women, without formal education or degrees, were able to do the work of professional foresters using their common sense, dedication, and teamwork.</p>
        <p>In the beginning, the writer and her team invited trained foresters to teach local women how to plant trees. However, the foresters, who had degrees, made the process too complicated. They used technical language and complex methods, which made it hard for the women to follow. The simple task of finding seeds and planting trees became unnecessarily difficult.</p>
        <p>Eventually, the writer and her team decided to teach the women themselves, using simple and practical steps. The women began searching for seeds in their local areas and learned how to identify seedlings that sprouted naturally. Although they didn't have diplomas or formal training, they used their natural skills, observation, and hard work to successfully plant and care for trees.</p>
        <p>These women, who had fewer opportunities than men and little access to education, proved that knowledge and skill are not limited to those with formal education. They became “foresters without diplomas” by learning through experience and supporting one another.</p>
        <p>In conclusion, the title captures the spirit of the essay perfectly. It highlights how women, without official qualifications, were able to make a big difference in their communities by protecting the environment and improving their own lives.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. Can a person make a difference in a society? Discuss with an example from a person who has made a difference in your society.</p>
        <p>= Sometimes, it may seem like one person cannot change the world because the problems we face are very big and difficult to solve. However, history shows us that one person can indeed make a difference, especially if they think and act in a unique or unconventional way.</p>
        <p>Many people have made important contributions not only to their own societies but also to the entire world. For example, Malala Yousafzai, a young girl from Pakistan, stood up for girls' education even when it was dangerous. Her courage helped raise awareness worldwide about the importance of education for all children. Another example is Nelson Mandela, who fought against racial discrimination in South Africa and helped bring peace and equality to his country.</p>
        <p>These examples prove that a single person can make a positive difference, not just locally but globally. When someone has the courage and determination to act, they can create changes that help many people.</p>
        <p>In conclusion, even though problems may seem too big, one person's actions can lead to great improvements in society and beyond.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>c. Write an essay on 'The Community Forest in Nepal'. Describe how these community forests have contributed to maintain ecology in our environment.</p>
        <p>= The Community Forestry Program in Nepal is a unique and successful way of managing forests that involves local people directly in protecting and using forest resources. This program helps both to conserve forests and to reduce poverty because many people in Nepal depend on agriculture and forest products for their daily lives.</p>
        <p>Over the past three decades, the program has changed a lot. It started with a focus on protecting forests but now includes using forests wisely, creating small businesses, and improving the livelihoods of local people. By 2009, about one-third of Nepal's people were part of this program, managing more than one-fourth of the country's forests themselves.</p>
        <p>Community forests provide many benefits. They help local families earn income and support their needs while protecting the environment. They also offer raw materials and investment opportunities for new businesses. This program is sustainable in many ways politically, financially, and ecologically because it has strong laws, good management, and active local groups.</p>
        <p>However, one challenge is to make sure that women and marginalized groups get equal benefits from the program. The success of community forestry in Nepal teaches us important lessons about learning from experience, creating strong community networks, flexible rules, and cooperation between the government and local people.</p>
        <p>In conclusion, the Community Forestry Program in Nepal has played a major role in protecting the environment and improving the lives of many people by encouraging local participation and sustainable forest management.</p>
      </div>
      <hr/>
      <div>
        <h3>Grammar</h3>
        <p className='question'>c. Underline the verb in each sentence and write whether it is transitive, intransitive or linking.</p>
        <p>a. His father looks handsome.</p>
        <p>looks = linking verb</p>
        <br/>
        <p>b. Bhawana drinks milk every day.</p>
        <p>drinks = transitive verb</p>
        <br/>
        <p>c. He became a watchman.</p>
        <p>became = linking verb</p>
        <br/>
        <p>d. This bread smells good.</p>
        <p>smells = linking verb</p>
        <br/>
        <p>e. The dog barked loudly.</p>
        <p>barked = intransitive verb</p>
        <br/>
        <p>f. He chased the dog.</p>
        <p>chased = transitive verb</p>
        <br/>
        <p>g. My sister swims fast.</p>
        <p>swims = intransitive verb</p>
        <br/>
        <p>h. He painted a picture.</p>
        <p>painted = transitive verb</p>
        <br/>
        <p>i. Radhika always asks questions.</p>
        <p>asks = transitive verb</p>
        <br/>
        <p>j. Anjana has a long hair.</p>
        <p>has = transitive verb</p>
        <br/>
        <p>k. Hungry lion roars.</p>
        <p>roars = intransitive verb</p>
        <br/>
        <p>l. He tried again and again.</p>
        <p>tried = intransitive verb</p>
        <br/>
        <p>m. The weather is hot.</p>
        <p>is = linking verb</p>
        <br/>
        <p>n. Owls hide in the daytime.</p>
        <p>hide = intransitive verb</p>
      </div>
    </div>
  )
}

export default Ecologyanddevelopment
